// Generated by https://pagedraw.io/pages/12008
import React from 'react';
import './incomingactionsmultistate.css';
import ContractForm from '../components/ContractForm'

import ContractData from '../components/ContractData'

export default class Incomingactionsmultistate extends React.Component {
  render() {
    return (
      <div className="incomingactionsmultistate">
          { ((this.props.incomingPaymentIndex == '-1' ? 'hideOptions' : 'showOptions') === "hideOptions") ?
              <div className="incomingactionsmultistate-hideoptions-2">
                  <div className="incomingactionsmultistate-0-0-0" /> 
                  <div className="incomingactionsmultistate-0-0-1">
                      <div className="incomingactionsmultistate-0-0-1-0" /> 
                      <div className="incomingactionsmultistate-rectangle_6">
                          <div className="incomingactionsmultistate-0-0-1-1-0">
                              <div className="incomingactionsmultistate-there_are_no_payments_being_sent_to_this_address_-8">
                                  There are no payments being sent to this address.
                              </div>
                          </div>
                      </div>
                      <div className="incomingactionsmultistate-0-0-1-2" /> 
                  </div>
                  <div className="incomingactionsmultistate-0-0-2" /> 
              </div>
          : null}
          { ((this.props.incomingPaymentIndex == '-1' ? 'hideOptions' : 'showOptions') === "showOptions") ?
              <div className="incomingactionsmultistate-showoptions-6">
                  <div className="incomingactionsmultistate-1-0-0" /> 
                  <div className="incomingactionsmultistate-1-0-1">
                      <div className="incomingactionsmultistate-1-0-1-0" /> 
                      <div className="incomingactionsmultistate-rectangle_5">
                          <div className="incomingactionsmultistate-1-0-1-1-0">
                              <div className="incomingactionsmultistate-1-0-1-1-0-0" /> 
                              <div className="incomingactionsmultistate-payment_data_placeholder_-8">
                                  <div>
                                      <ContractData contract="ScorchablePayments" method="payments" isTokenValue={0} keysToScale={["amount", "payeeBondAmount"]} keysToExclude={["isEthPayment", "listIndex"]} keysToRename={{"amount": this.props.getIncomingAmountString}} prefix="" methodArgs={[this.props.incomingPaymentIndex]} onDataCallback={this.props.incomingPaymentDataCallback}/>
                                  </div>
                              </div>
                              <div className="incomingactionsmultistate-1-0-1-1-0-2" /> 
                          </div>
                          <div className="incomingactionsmultistate-1-0-1-1-1">
                              <div className="incomingactionsmultistate-1-0-1-1-1-0" /> 
                              <div className="incomingactionsmultistate-paybondpaceholder-2">
                                  <div>
                                      <ContractForm contract="ScorchablePayments" method="payBond" purpose="Pay Bond" fixedParams={[this.props.incomingPaymentIndex]} paramNamesToScale={[]} labels={["Payment ID:"]}  placeholders={["0"]} amountInputs={{"conditional": this.props.incomingPaymentEthBondSize() > 0, "value": this.props.incomingPaymentEthBondSize()}}/> 
                                  </div>
                              </div>
                              <div className="incomingactionsmultistate-1-0-1-1-1-2" /> 
                          </div>
                          <div className="incomingactionsmultistate-1-0-1-1-2">
                              <div className="incomingactionsmultistate-returntokenstosenderplaceholder-2">
                                  <div>
                                      <ContractForm contract="ScorchablePayments" method="returnTokensToSender" purpose="Return to Sender" fixedParams={[this.props.incomingPaymentIndex, -1]} paramNamesToScale={["amount"]} labels={["Payment ID:", "Amount:"]}  placeholders={["0", "0.0"]}/> 
                                  </div>
                              </div>
                          </div>
                          <div className="incomingactionsmultistate-1-0-1-1-3">
                              <div className="incomingactionsmultistate-1-0-1-1-3-0" /> 
                              <div className="incomingactionsmultistate-claimtimedoutpaymentplaceholder-5">
                                  <div>
                                      <ContractForm contract="ScorchablePayments" method="claimTimedOutPayment" purpose="Claim Payment" fixedParams={[this.props.incomingPaymentIndex]} paramNamesToScale={[]} labels={["Payment ID:"]}  placeholders={["0"]}/> 
                                  </div>
                              </div>
                              <div className="incomingactionsmultistate-1-0-1-1-3-2" /> 
                          </div>
                          <div className="incomingactionsmultistate-1-0-1-1-4" /> 
                      </div>
                      <div className="incomingactionsmultistate-1-0-1-2" /> 
                  </div>
                  <div className="incomingactionsmultistate-1-0-2" /> 
              </div>
          : null}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/pagedraw/incomingactionsmultistate.js